import { Fragment } from 'react';

import { HSpacing } from '@hh.ru/magritte-ui';
import MetroPin from 'bloko/blocks/metroPin';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import Divider from 'src/components/ResumeCard/Divider';
import translation from 'src/components/translation';
import { Relocation } from 'src/models/resume/resumeCommon.types';
import type { ResumeCardData } from 'src/models/resumeCard';
import { REGULAR_SPACE } from 'src/utils/constants/symbols';

import CollapseText from 'src/components/ResumeCard/Body/Collapse/Text';
import Field from 'src/components/ResumeCard/Body/Field';

const TrlKeys = {
    title: 'resume.search.field.areaAndRelocation',
    metroPrefix: 'rb.edit.metro.m',
    relocation: 'resume.search.field.relocation',
    [Relocation.NoRelocation]: 'resume.search.relocation.no_relocation',
    [Relocation.RelocationPossible]: 'resume.search.relocation.relocation_possible',
    [Relocation.RelocationDesirable]: 'resume.search.relocation.relocation_desirable',
};

const AreaAndRelocation: TranslatedComponent<{ resume: ResumeCardData }> = ({ resume, trls }) => {
    const area = resume.area?.[0]?.trl;
    if (!area) {
        return null;
    }

    const metroStations = resume.metroStation;
    const relocation = resume.relocation?.[0]?.string;
    const relocationArea = resume.relocationArea;

    return (
        <Field title={trls[TrlKeys.title]} dataQaName="area-and-relocation">
            <CollapseText dataQa="area-and-relocation">
                {area}
                {metroStations?.map((station) => (
                    <Fragment key={station.id}>
                        <HSpacing default={4} />
                        <MetroPin color={station.color} />
                        {trls[TrlKeys.metroPrefix]}
                        {REGULAR_SPACE}
                        {station.trl}
                    </Fragment>
                ))}
                {relocation && (
                    <>
                        <Divider />
                        {trls[TrlKeys[relocation]]}
                        {relocationArea && relocationArea?.length > 0 && (
                            <>
                                {': '}
                                {relocationArea.map((relocationArea) => relocationArea.trl).join(', ')}
                            </>
                        )}
                    </>
                )}
            </CollapseText>
        </Field>
    );
};

export default translation(AreaAndRelocation);
